import { useState } from "react";
import SortIcon from "@mui/icons-material/Sort";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Popper,
  Paper,
  ClickAwayListener,
  Divider,
  Typography,
  IconButton,
} from "@mui/material";
import OrderByOptions from "./OrderByOptions";

const RadioButtonDropdown = ({
  options,
  title,
  selectedOption,
  setSelectedOption,
}: {
  options: string[];
  title: string;
  selectedOption: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    setSelectedOption("");
  };

  const buttonTitle =
    selectedOption && selectedOption !== ""
      ? selectedOption.split(" ").slice(1).join(" ")
      : title;

  return (
    <Box>
      <Button
        variant="outlined"
        onClick={handleToggle}
        sx={{
          border:
            selectedOption && selectedOption !== ""
              ? "2px solid #1565c0"
              : "1px solid #bdbdbd",
          borderRadius: "50px",
          px: 2,
          textTransform: "capitalize",
          color: selectedOption && selectedOption !== "" ? "#1565c0" : "black",
          display: "flex",
          alignItems: "center",
          backgroundColor:
            selectedOption && selectedOption !== "" ? "#e3f2fd" : "white",
          "&:hover": { border: "1px solid black", backgroundColor: "white" },
          "&:focus": {
            border: "2px solid #1565c0",
            backgroundColor: "#e3f2fd",
            color: "#1565c0",
          },
        }}
      >
        <SortIcon sx={{ pr: 0.5, fontSize: "medium" }} />
        {buttonTitle}
        {selectedOption && selectedOption !== "" && (
          <IconButton
            size="small"
            onClick={handleClear}
            sx={{ ml: 1, p: 0, color: "#1565c0" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Button>

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="bottom-start"
        sx={{ zIndex: 999 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              width: { xs: "200px", md: "320px" },
              boxShadow: 3,
              borderRadius: "10px",
              px: "20px",
              py: "10px",
            }}
          >
            <OrderByOptions
              options={options}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
            />

            <Divider sx={{ my: 1 }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Typography
                onClick={handleClear}
                sx={{
                  textTransform: "capitalize",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Clear
              </Typography>
              <Button
                variant="contained"
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "black",
                  color: "white",
                  px: 2,
                  "&:hover": { backgroundColor: "#333" },
                }}
                onClick={handleClose}
              >
                Save
              </Button>
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default RadioButtonDropdown;
